import React from "react";
import PageTitle from "../../components/PageTitle";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import moment from "../../helpers/moment";
import is_money from "../../helpers/is_money";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import StartNewApplication from "./StartNewApplication";
import PrintSlip from "./PrintSlip";

const NewApplication = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["paymentList"],
    queryFn: async () => {
      const req = await axiosget("ms_application_fee");
      return req?.data;
    },
  });

  return (
    <>
      <PageTitle title={`Start New Application`} sub={`Applicant is allowed to apply for multiple courses but only one will be offered admission`} />
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
      <div className="row">
        {data &&
          data?.type === undefined &&
          data?.map((v, i) => (
            <div className="col-md-6 my-4" key={`_payments_for_applications_${i}`}>
              <div className="card border border-success">
                <div className="card-body">
                  <p className="card-text">
                    <b>Remita RRR:</b> {v?.trxcode}
                  </p>
                  <p className="card-text">
                    <b>Amount: </b>
                    {is_money(v?.amount)}
                  </p>
                  <p className="card-text">
                    <b>Description:</b> {v?.trxdata?.description}
                  </p>
                  <p className="card-text">
                    <b>Is Used For Application:</b> {v?.application ? `Has been used` : "Not used"}
                  </p>
                  <p className="card-text">
                    <b>Is Payment Verified: </b>
                    {v?.isverified ? `Verified` : "Not Verified"}
                  </p>
                  <p className="card-text">
                    <b>Generated:</b> {moment(v.createdAt)} ago
                  </p>
                </div>
                <div className="card-footer text-body-secondary">
                  {v?.application === null ? <StartNewApplication v={v} /> : <PrintSlip v={v} key={`print_slip_key_${i}`} />}
                </div>
              </div>
            </div>
          ))}
      </div>
      {/* <MainNewApplication /> */}
    </>
  );
};

export default NewApplication;
